import { createContext, useContext } from "react";

const ConversationContentContext = createContext({});

export const ConversationContentContextProvider = ConversationContentContext.Provider;
export const ConversationContentContextConsumer = ConversationContentContext.Consumer;

export const useConversationContentContext = () => useContext(ConversationContentContext);

export default ConversationContentContext;
